import AutocompleteTagModule from './autocomplete-tag.module'

export default AutocompleteTagModule
